import AddIcon from '@mui/icons-material/Add';
import { Button, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import WorkPlaceBox from '../../components/navbar/WorkPlaceBox.jsx';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1, 0, 3),
}));

export default function CreateBrandToolbar({ handleRefreshGrid, compact = false }) {
  const { t: translate } = useTranslation();
  const [openWorkPlaceModal, setWorkPlaceModal] = useState(false);
  const handleWorkPlaceClick = () => {
    setWorkPlaceModal(true);
  };
  const handleClose = () => {
    setWorkPlaceModal(false);
  };
  const handleSuccess = () => {
    setWorkPlaceModal(false);
    handleRefreshGrid(true);
  };

  return (
    <>
      <StyledRoot sx={compact ? { height: 'auto', minHeight: '0 !important', p: '0 !important' } : undefined}>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleWorkPlaceClick}>
          {translate('brand.create_brand')}
        </Button>
      </StyledRoot>
      {openWorkPlaceModal && <WorkPlaceBox handleClose={handleClose} handleSuccess={handleSuccess} />}
    </>
  );
}
